import { useMemo } from 'react';
import { useViewMode } from 'store/app/appStore';
import { SINGLE_VIEW_MODE } from '../../../../constants';
import singleViewStyles from '../../components/shared/PrizeFundCampaign/css/SingleViewPrizeFundCampaign.module.css';
import multiViewStyles from '../../components/shared/PrizeFundCampaign/css/MultiViewPrizeFundCampaign.module.css';
import type { PrizeFundCampaignStyles } from '../../components/shared/PrizeFundCampaign/css/base/PrizeFundCampaign';
import singleViewBadgeStyles from '../../components/shared/PrizeFundCampaign/CampaignBadge/css/SingleViewCampaignBadge.module.css';
import multiViewBadgeStyles from '../../components/shared/PrizeFundCampaign/CampaignBadge/css/MultiViewCampaignBadge.module.css';
import type { CampaignBadgeStyles } from '../../components/shared/PrizeFundCampaign/CampaignBadge/css/base/CampaignBadg';
import sharedCardStyles from '../../components/shared/CampaignCard/CampaignCardStyles.module.css';
import type { CampaignCardStyles } from '../../components/shared/CampaignCard/CampaignCardStyles';
import campaignCardStyles from '../../components/defaults/CampaignCard/css/CampaignCard.module.css';
import type { CampaignCard } from '../../components/defaults/CampaignCard/css/CampaignCard.modules';

export const useCampaignCardStyles = () => {
  const viewMode = useViewMode();

  const getPrizeFundCampaignStyles = useMemo(() => {
    return (): PrizeFundCampaignStyles => {
      return (viewMode === SINGLE_VIEW_MODE ? singleViewStyles : multiViewStyles) as unknown as PrizeFundCampaignStyles;
    };
  }, [viewMode]);

  const getCampaignBadgeStyles = useMemo(() => {
    return (): CampaignBadgeStyles => {
      return (viewMode === SINGLE_VIEW_MODE ? singleViewBadgeStyles : multiViewBadgeStyles) as unknown as CampaignBadgeStyles;
    };
  }, [viewMode]);

  const getSharedCardStyles = useMemo(() => {
    return (): CampaignCardStyles => {
      return sharedCardStyles as unknown as CampaignCardStyles;
    };
  }, []);

  const getCampaignCardStyles = useMemo(() => {
    return (): CampaignCard => {
      return campaignCardStyles as unknown as CampaignCard;
    };
  }, []);

  return {
    getPrizeFundCampaignStyles,
    getCampaignBadgeStyles,
    getSharedCardStyles,
    getCampaignCardStyles,
  };
};
